/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formDropoffAnalyticsDataSchema = z.object({
	formId: z.string(),
	period: z.array(z.string()),
	totalSessions: z.number(),
	completedSessions: z.number(),
	overallCompletionRate: z.number(),
	questions: z.array(
		z.object({
			questionId: z.string(),
			position: z.number(),
			label: z.string(),
			type: z.string(),
			attribute: z.string().nullable(),
			sessionsViewed: z.number(),
			sessionsAnswered: z.number(),
			dropoffCount: z.number(),
			dropoffRate: z.number(),
			cumulativeDropoffRate: z.number(),
		}),
	),
})

export type FormDropoffAnalyticsDataSchema = z.infer<typeof formDropoffAnalyticsDataSchema>
